import { useState } from "react";
import PasswordCheckList from "react-password-checklist";
import { useNavigate } from "react-router-dom";

// styles and images
import "./SignUp.css";
import "../login/Login.css";
import togglePwOn from "../../assets/pw_vis_on.svg";
import togglePwOff from "../../assets/pw_vis_off.svg";
import InputField from "../../formComponents/InputField";

export default function SignUp() {
  // local
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passwordCheck, setPasswordCheck] = useState("");
  const [passwordValid, setPasswordValid] = useState(false);
  const [pwIcon, setPwIcon] = useState(togglePwOn);
  const [showPassword, setShowPassword] = useState(false);
  const [displayName, setDisplayName] = useState("");
  const [formError, setFormError] = useState(null);
  const [isPending, setIsPending] = useState(false);

  // other
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    const controller = new AbortController();
    setIsPending(true);
    if (!passwordValid) {
      setFormError("There is an issue with you password, see guidelines🤯");
      setIsPending(false);
      return;
    }
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    const requestOptions = {
      method: "GET",
      headers,
      signal: controller.signal,
    };
    if (email) {
      fetch(
        `${process.env.REACT_APP_BACKEND}/users/approval-status/${email}`,
        requestOptions,
      )
        .then((res) => {
          return res.json();
        })
        .then((data) => {
          if (!data) {
            setFormError("Something Went Wrong");
            return;
          } else if (data.error) {
            setFormError(data.message);
            return;
          } else {
            const user = {
              id: data.id,
              user_password: password,
              display_name: displayName,
            };

            if (!data.error && data.message === "User does not exist") {
              setFormError("Unauthorized");
              setIsPending(false);
            } else if (!data.is_approved) {
              setFormError(
                "User is not approved, please contact Administrator",
              );
              setIsPending(false);
            } else if (data.is_approved) {
              requestOptions.method = "PATCH";
              requestOptions.body = JSON.stringify(user);
              fetch(
                `${process.env.REACT_APP_BACKEND}/signup`,
                requestOptions,
              ).then((res) => {
                if (!res.ok) {
                  if (res.status === 403) {
                    setIsPending(false);
                    setFormError("This user cannot create an account");
                    return;
                  }
                  setIsPending(false);
                  setFormError("Something Went Wrong");
                  return;
                }
                navigate("/login");
                setIsPending(false);
              });
            }
          }
        })
        .catch((_) => {
          setFormError("Something went wrong");
          return;
        })
        .finally(() => setIsPending(false));
      return () => controller.abort();
    }
  };

  const togglePassword = () => {
    if (!showPassword) {
      setShowPassword(true);
      setPwIcon(togglePwOff);
    } else {
      setShowPassword(false);
      setPwIcon(togglePwOn);
    }
  };

  return (
    <div className="container">
      <div className="row d-flex justify-content-center align-items-center h-100">
        <div className="col-12 col-md-8 col-lg-6 col-xl-5">
          <div
            className="card shadow-2-strong"
            style={{ borderRadius: "1rem" }}
          >
            <div className="card-body p-5 text-center">
              <h2>Sign Up</h2>
              <form onSubmit={handleSubmit}>
                <InputField
                  name={"email"}
                  title={"Email"}
                  type={"email"}
                  className={"form-control"}
                  placeholder={"Email Address"}
                  value={email}
                  required={true}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <div className="form-outline mb-4">
                  <label className="form-label">Password</label>
                  <div className="pw-container">
                    <input
                      type={!showPassword ? "password" : "text"}
                      className="form-control form-control-lg"
                      required
                      onChange={(e) => setPassword(e.target.value)}
                      value={password}
                    />
                    <img
                      src={pwIcon}
                      className="password-toggle"
                      onClick={togglePassword}
                      alt="toggle"
                    />
                  </div>
                </div>
                <div className="form-outline mb-4">
                  <label className="form-label">Password Verification</label>
                  <div className="pw-container">
                    <input
                      type={!showPassword ? "password" : "text"}
                      className="form-control form-control-lg"
                      required
                      onChange={(e) => setPasswordCheck(e.target.value)}
                      value={passwordCheck}
                    />
                    <img
                      src={pwIcon}
                      className="password-toggle"
                      onClick={togglePassword}
                      alt="toggle"
                    />
                  </div>
                </div>
                <PasswordCheckList
                  rules={[
                    "minLength",
                    "specialChar",
                    "number",
                    "capital",
                    "match",
                  ]}
                  minLength={10}
                  value={password}
                  valueAgain={passwordCheck}
                  onChange={(isValid) => setPasswordValid(isValid)}
                />
                <InputField
                  name={"display_name"}
                  title={"Display Name"}
                  type={"text"}
                  className={"form-control"}
                  placeholder={"Display Name"}
                  value={displayName}
                  required={true}
                  onChange={(e) => setDisplayName(e.target.value)}
                />
                {!isPending && <button className="propx-btn">Sign Up</button>}
                {isPending && (
                  <button className="propx-btn" disabled>
                    Loading
                  </button>
                )}
                {formError && <div className="error">{formError}</div>}
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
